import PaginationCustom from "../PaginationCustom";
import React, { useState, useCallback, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import { Column } from "../../style";
import { HeaderList } from "../HeaderList";
import { ContainerPagination } from "./style";
import { DashboardPage } from "../DashboardPage";
import { ITableList, TableList } from "../TableList";
import { IActions, IFilters, themeTypes } from "../../interfaces";
import { SearchWithFilters, FiltersRef } from "../SearchWithFilters";
import { Alert, Text } from "@mantine/core";
import { FiAlertCircle } from "react-icons/fi";
import { useGlobal } from "../../hooks/global";

interface IPageList extends ITableList {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  numberOfItems: number;
  actions?: IActions[];
  onClickOption?: (action_id: string) => void;
  textHeader: string;
  textItems: string;
  theme: themeTypes;
  initialFilters: IFilters[];
  updatedAt: any;
  pages: number;
  page: number;
  search: Function;
  onChangeFilters?: (filters: any) => void;
  onChangeSearch?: (search: string) => void;
  noActions?: boolean;
  noPagination?: boolean;
  children?: any;
  setBusinessIdSelected?: React.Dispatch<React.SetStateAction<string | null>>;
  textAlertTitle?: string;
  textAlertDescription?: string;
}

export interface PageListRef {
  setFilters: React.Dispatch<React.SetStateAction<IFilters[]>>;
}

const PageListComponent: React.ForwardRefRenderFunction<PageListRef, IPageList> = (props, ref) => {
  const { theme } = useGlobal();

  const { search, onChangeFilters = () => { }, onChangeSearch = () => { }, noPagination } = props;

  const [selecteds, setSelecteds] = useState<string[]>([]);
  const [searchString, setSearchString] = useState<string>("");
  const [controlSearch, setControlSearch] = useState<boolean>(false);

  const filter_ref = useRef<FiltersRef>(null);

  const handleChangeSelecteds = useCallback(
    (selecteds: string[]) => {
      setSelecteds(selecteds);
      if (props.onChangeSelecteds) props.onChangeSelecteds(selecteds);
    },
    [props]
  );

  const handleSubmitFilters = useCallback(
    ({ filters }: any) => {
      onChangeFilters(filters);
      search(1, { ...filters, search: filter_ref.current?.getSearch() ?? "" });
    },
    [filter_ref]
  );

  const handleChangeSearch = useCallback(
    (value: string) => {
      setSearchString(value);
      return search(1, { ...filter_ref.current?.getFilters(), search: value });
    },
    [filter_ref]
  );

  useEffect(() => {
    onChangeSearch(searchString);
    setControlSearch((atual) => !atual);
  }, [searchString]);

  const childrenPaginationCustom = (
    <ContainerPagination>
      <PaginationCustom
        {...props}
        disable={props.loading}
        onChange={(value: any) =>
          search(value, {
            ...filter_ref?.current?.getFilters(),
            search: searchString,
          })
        }
      />
    </ContainerPagination>
  );

  const childrenHeaderList = (
    <HeaderList
      {...props}
      selecteds={selecteds}
      actions={props?.actions || []}
      onRefresh={() =>
        search(1, { ...filter_ref.current?.getFilters(), search: searchString })
      }
    />
  );

  useImperativeHandle(ref, () => ({ setFilters: filter_ref?.current?.setFilters as any }));

  return (
    <DashboardPage>

      <Column style={{ flex: 1 }}>
        {controlSearch && childrenHeaderList}

        {!controlSearch && childrenHeaderList}

        <SearchWithFilters
          {...props}
          ref={filter_ref}
          clickButtonSearch={(filters: any) => handleSubmitFilters({ filters })}
          onChangeSearch={handleChangeSearch}
        />

        {props?.textAlertTitle && (
          <Alert icon={<FiAlertCircle size="1.1rem" />} title={props?.textAlertTitle} style={{
            backgroundColor: theme === "dark" ? 'rgba(250,176,5,.15)' : 'rgba(250,176,5,.1)',
            color: theme === "dark" ? '#FFE066' : '#FAB005',
            marginTop: '1.5rem',
          }}>
            <Text color={theme === "dark" ? '#fff' : '#3A3A3A'} style={{ fontFamily: 'Poppins' }}>{props?.textAlertDescription}</Text>
          </Alert>
        )}

        <TableList {...props} onChangeSelecteds={handleChangeSelecteds} />
      </Column>

      {!noPagination && controlSearch && childrenPaginationCustom}

      {!noPagination && !controlSearch && childrenPaginationCustom}

      {props.children}
    </DashboardPage>
  );
};

export const PageList = forwardRef(PageListComponent);